import React from 'react';
import { withProviders } from '../../../contexts/main/withProviders';
import { ISinglePaymentPageProps } from './interfaces';
import { PaymentWidgetContainer } from '../components/PaymentWidget/PaymentWidgetContainer';
import { PaymentCheckoutContainer } from '../components/PaymentCheckout/PaymentCheckoutContainer';
import { withChallengeData } from '../../../contexts/storage-contexts/Challenge';
import { withGeneralData } from '../../../contexts/GeneralDataProvider/withGeneralData';
import { withUser } from '../../../contexts/User/withUser';
import { withLocation } from '../../../contexts/Location/withLocation';
import { useEnvironment, useExperiments } from '@wix/yoshi-flow-editor';
import { ApplyCouponToOrderResponse } from '@wix/ambassador-challenges-v1-participant/types';
import { PaymentJoinButton } from '../components/PaymentJoinButton/PaymentJoinButton';
import { FCWithChildren } from '@wix/challenges-web-library';
import { st, classes } from './Widget.st.css';
import { PaymentPageV1 } from './PaymentPageV1';
import { Spinner } from 'wix-ui-tpa/cssVars';

const PaymentPageOld: FCWithChildren<ISinglePaymentPageProps> = () => {
  const { isMobile, isRTL } = useEnvironment();
  const [coupon, setCoupon] = React.useState<ApplyCouponToOrderResponse>(null);
  const isCouponZeroPrice = parseFloat(coupon?.total) === 0;
  const [renderPaymentWidget, setRenderPaymentWidget] =
    React.useState<boolean>(false);

  React.useEffect(() => {
    // render payment widget after hydration
    setRenderPaymentWidget(true);
    window?.scrollTo?.(0, 0);
  }, []);

  return (
    <section
      data-hook="challenges-payment-page"
      className={st(classes.root, {
        mobile: isMobile,
        rtl: isRTL,
      })}
    >
      {isCouponZeroPrice ? (
        <div className={classes.paymentWidgetWrapper}>
          <PaymentJoinButton />
        </div>
      ) : (
        <div className={classes.paymentWidgetWrapper}>
          {renderPaymentWidget && (
            <PaymentWidgetContainer
              onApiReady={() => {}}
              onWidgetLoaded={() => {}}
            />
          )}
        </div>
      )}
      <div className={classes.checkoutLayout}>
        <PaymentCheckoutContainer
          onCouponApplied={(_coupon) => {
            setCoupon(_coupon);
          }}
        />
      </div>
    </section>
  );
};

export const PaymentPage = (props: ISinglePaymentPageProps) => {
  const { experiments } = useExperiments();
  const { isForcedBlankPage = false } = props;

  if (isForcedBlankPage) {
    return (
      <div className={classes.loader}>
        <Spinner diameter={50} />
      </div>
    );
  }

  if (experiments.enabled('spec.programs.CreateParticipantOnPaymentPage')) {
    return <PaymentPageV1 {...props} />;
  }
  return <PaymentPageOld {...props} />;
};

export default withProviders(
  withUser(withGeneralData(withLocation(withChallengeData(PaymentPage)))),
);
